export class Helper {
  public static validateDate(dateString: string): boolean {
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
      return false;
    }

    const parts = dateString.split('/');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    if (year < 1000 || year > 4000 || month === 0 || month > 12) {
      return false;
    }

    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29;
    }

    return day > 0 && day <= monthLength[month - 1];
  }

  public static validateMonthYear(dateString: string): boolean {
    if (!/^\d{1,2}\/\d{4}$/.test(dateString)) {
      return false;
    }

    const parts = dateString.split('/');
    const month = parseInt(parts[0], 10);
    const year = parseInt(parts[1], 10);

    if (year < 1000 || year > 4000 || month === 0 || month > 12) {
      return false;
    }

    return true;
  }

  public static dateToString(date: Date | null | undefined): string {
    if (!date) {
      return '';
    }

    return (
      this.formatWithLeadingZero(date.getDate()) +
      '/' +
      this.formatWithLeadingZero(date.getMonth() + 1) +
      '/' +
      date.getFullYear()
    );
  }

  public static formatWithLeadingZero(value: number): string {
    if (value > 9) {
      return value.toString();
    }

    return '0' + value.toString();
  }

  public static toDate(dateStr: string, formattedWithDayFirst = false): Date | null {
    if (!formattedWithDayFirst) {
      return new Date(dateStr);
    }

    const dateSplit = dateStr.split('/');

    if (dateSplit.length !== 3) {
      return null;
    }

    dateStr = dateSplit[1] + '/' + dateSplit[0] + '/' + dateSplit[2];

    return new Date(dateStr);
  }

  public static getMonthDifferenceFromToday(date: Date): number {
    const today = new Date();

    return (date.getFullYear() - today.getFullYear()) * 12 + (date.getMonth() - today.getMonth());
  }

  public static dateIsInTheFuture(date: Date): boolean {
    const today = new Date();

    return date > today;
  }

  public static validateEmail(email: string): boolean {
    const at = email.indexOf('@');
    const dot = email.lastIndexOf('.');

    return (
      email.length > 0 &&
      at > 0 &&
      dot > at + 1 &&
      dot < email.length - 1 &&
      email[at + 1] !== '.' &&
      email.indexOf(' ') === -1 &&
      email.indexOf('..') === -1
    );
  }

  public static validatePhone(phone: string): boolean {
    const reg = new RegExp('^[0-9 ]+$');

    return reg.test(phone);
  }
}
